import React from "react";

interface Data {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
}
const ComparisonTable: React.FC<{ data: Data[] }> = ({ data }) => (
    <table className={"table-advice-style"} style={{fontFamily: '源ノ角ゴシック JP', marginTop: '24px'}}>
        <thead>
        <tr>
            <th className={'p-4'}>要因</th>
            <th style={{ width: '8%' }} className={'p-4'}>スコア</th>
            <th style={{ width: '8%' }} className={'p-4'}>偏差値</th>
        </tr>
        </thead>
        <tbody>
        {data.map((item, index) => (
            <tr key={index}>
                <td className={'p-4'}>{item.groupTitle}</td>
                <td className={'data-point-green base'}>{item.totalPoint}</td>
                <td className={'data-point-green base'}>{item.deviation}</td>
            </tr>
        ))}
        </tbody>
    </table>
);

export default ComparisonTable;
